import { observer } from 'mobx-react-lite'

import { useCrudResourceContext } from '@/Core/UI/CrudResource/CrudResourceContextProvider'
import { UserAvatarContent } from '@/Ship/Components/UI/UserPhoto/UserAvatarContent'
import { cx } from '@/Ship/Helpers/cssClass'
import { resolveUserPhotoUrl } from '@/Ship/Helpers/userPhoto'
import { resolveInitials } from '@/Ship/Templates/Layouts/Components/UserProfileBlock/UserProfileBlock'

import styles from './UserPhotoView.module.css'

interface UserPhotoViewProps {
    formContext: any
}

/**
 * «Фотографія» у перегляді картки: круглий аватар або «—», якщо фото немає.
 * Поле типу file ядро й у перегляді рендерить як список файлів у шаблоні редагування,
 * тому для перегляду — власний рядок у розмітці полів перегляду.
 */
export const UserPhotoView = observer(({ formContext }: UserPhotoViewProps) => {
    const crudContext = useCrudResourceContext() as any
    const label = crudContext?.resource?.fields?.photo?.label ?? 'Фотографія'
    const photo = formContext.values?.photo
    const url = resolveUserPhotoUrl(photo)
    const initials = resolveInitials(String(formContext.values?.fullName ?? ''))

    return (
        <div className="form-field-view">
            <div className="field-view-label">{label}</div>
            <div className={url ? 'field-view-value' : 'field-view-value is-empty'}>
                {url ? (
                    <span className={cx(styles, 'avatar')}>
                        <UserAvatarContent photo={photo} initials={initials} />
                    </span>
                ) : (
                    '—'
                )}
            </div>
        </div>
    )
})
